var routes = [

	
	{
		name: "edit-page",
		path: "/edit/:name?/:tag?/post/:postid?",
		component: () => import("@/views/EditPage"),
	},
	{
		name: "footer-edit-page",
		path: "/footer/:list_id",
		component: () => import("@/views/lists/FooterEditorPage"),
	},

	
    {
		path: "/",
		component: () => import(/* webpackChunkName: "journal" */"@/app/JournalWebapp"),
		children: [

			//Posts Lists
			{
				path: "/",
				component: () => import(/* webpackChunkName: "journal" */"@/views/knowledge/Home"),
				children: [
					{
						name: "post-listing",
						path: "review",
						component: () => import(/* webpackChunkName: "journal" */"@/views/knowledge/ReviewPosts"),
						alias: "/",
						meta: {
							postView: "review-post-view",
							load: "reloadPostListings"
						}
					},
					{
						name: "category-posts",
						path: "recent",
						component: () => import(/* webpackChunkName: "journal" */"@/views/knowledge/RecentPosts"),
						meta: {
							postView: "post-view",
							load: "loadPosts"
						}
					},
					{
						name: "ordered-posts",
						path: "ordered",
						component: () => import(/* webpackChunkName: "journal" */"@/views/knowledge/OrderedPosts"),
						meta: {
							postView: "ordered-post-view",
							load: "loadOrderedPosts"
						}
					},
				],

			},

			{
				path: "/listing",
				component: () => import(/* webpackChunkName: "journal" */"@/views/knowledge/CategoryPosts"),
				children: [
					{
						name: "category-listing",
						path: "review",
						component: () => import(/* webpackChunkName: "journal" */"@/views/knowledge/ReviewPosts"),
						alias: "/",
						meta: {
							postView: "review-post-view",
							load: "reloadPostListings"
						}
					},
					{
						name: "category-listing-review",
						path: "recent",
						component: () => import(/* webpackChunkName: "journal" */"@/views/knowledge/RecentPosts"),
						meta: {
							postView: "post-view",
							load: "loadPosts"
						}
					},
					{
						name: "category-listing-ordered",
						path: "ordered",
						component: () => import(/* webpackChunkName: "journal" */"@/views/knowledge/OrderedPosts"),
						meta: {
							postView: "ordered-post-view",
							load: "loadOrderedPosts"
						}
					},
				],
			},
			
			
						
			{
				name: "post-tag-listing",
				path: "posts/tags/:tag",
				component: () => import(/* webpackChunkName: "journal" */"@/views/knowledge/TaggedPosts"),
				meta: {
					postView: "tag-post-view",
					load: "loadTaggedPosts"
				}
			},	
			{
				name: "search-posts",
				path: "search/:query",
				component: () => import(/* webpackChunkName: "journal" */"@/views/knowledge/SearchPosts"),
				meta: {
					postView: "search-post-view",
					load: "searchPosts"
				}
			},
			
      	]
    },

	//Post Views
	{
		name: "search-post-view",
		path: "/search/view",
		component: () => import("@/views/knowledge/ViewPostPage"),
		props: true,
		meta:{
			load: "getPostInfo",
			loadMore:"loadMorePosts"
		}
	},
	{
		name: "post-view",
		path: "/postview",
		component: () => import("@/views/knowledge/ViewPostPage"),
		props: true,
		meta:{
			load: "getPostInfo",
			loadMore:"loadMorePosts",
		}
	},
	{
		name: "review-post-view",
		path: "/post/review",
		component: () => import("@/views/knowledge/ViewPostPage"),
		props: true,
		meta:{
			load: "getPostInfo",
			loadMore:"loadMorePostReview"
		}
	},
	{
		name: "ordered-post-view",
		path: "/post/ordered",
		component: () => import("@/views/knowledge/ViewPostPage"),
		props: true,
		meta:{
			load: "getPostInfo",
			loadMore:"loadMorePostsOrdered"
		}
	},
	{
		name: "tag-post-view",
		path: "/tagged/post",
		component: () => import("@/views/knowledge/ViewPostPage"),
		props: true,
		meta:{
			load: "getPostInfo",
			loadMore:"loadMorePosts"
		}
	},

	{
		path: "/",
		component: () => import(/* webpackChunkName: "list" */"@/app/ListWebapp"),
		children: [
			//Lists
			{
				name: "list",
				path: "/list/:list_id?",
				component: () => import(/* webpackChunkName: "list" */"@/views/lists/List"),

			},

			{
				name: "list-labs",
				path: "/labs/:list_id?",
				component: () => import(/* webpackChunkName: "list" */"@/views/lists/ListLabs"),

			},


		],
	},


	{
		path: "/",
		component: () => import("@/app/Webapp"),
		children: [

			//DASHBOARD

			{
				name: "dashboard",
				path: "/dashboard",
				component: () => import(/* webpackChunkName: "dash" */"@/views/Dashboard"),
			},

			{
				name: "about",
				path: "/about",
				component: () => import("@/views/general/About")
			},
			{
				name: "help",
				path: "/help",
				component: () => import("@/views/general/Help")
			},

			{
				name: "sos-updating",
				path: "/updating",
				component: () => import("@/views/Settings/SosUpdating")
			},

			//USERS
					
			{
				// name: "manage-users",
				path: "manage",
				//component: () => import("@/views/UserSettings/ManageUsers"),
				component: () => import(/* webpackChunkName: "manage-users" */"@/views/manageUsers/ManageUsers"),
				children: [	
					{
						name: "userList",
						path: "users",
						component: () => import(/* webpackChunkName: "manage-users" */"@/views/manageUsers/UserList")
					},
					{
						name: "userCreate",
						path: "create/user",
						component: () => import(/* webpackChunkName: "manage-users" */"@/views/UserSettings/CreateUser")
					},
					{
						path: "",
						component: () => import(/* webpackChunkName: "manage-users" */"@/views/UserSettings/InviteRoute"),
						children: [

							{
								name: "sendInvite",
								path: "invites",
								component: () => import(/* webpackChunkName: "manage-users" */"@/views/UserSettings/SendInvite"),
								props: true
							},
							{
								name: "viewCode",
								path: "invite/:code",
								component: () => import(/* webpackChunkName: "manage-users" */"@/views/UserSettings/ViewInvite"),
							}
						]
					},
					
					
				]
			},	

			

			{
				name: "profile-settings",
				path: "profile/:uid",
				component: () => import("@/views/profileSettings/ProfileSettings"),
				children:[
					{
						name: "profile-view",
						path: "view",
						component: () => import("@/views/profileSettings/ProfileView")
					},	
					{
						name: "profile",
						path: "settings",
						component: () => import("@/views/profileSettings/Profile")
					},	
					{
						name: "password",
						path: "password",
						component: () => import("@/views/profileSettings/Password")
					},
					{
						name: "profile-lists",
						path: "lists",
						component: () => import("@/views/profileSettings/ProfileLists")
					},
				]
			},

			{
				name: "password-reset",
				path: "reset/password",
				component: () => import("@/views/profileSettings/ResetPassword")

			},
			
			//SETTINGS
			{
				path: "/settings",
				props: true,
				component: () => import(/* webpackChunkName: "settings" */"@/views/Settings/Settings"),
				children: [	
	
					{
						name: "update",
						path: "update",
						component: () => import(/* webpackChunkName: "settings" */"@/views/Settings/Update")
					},					
					{
						name: "theme",
						path: "theme",
						component: () => import(/* webpackChunkName: "settings" */"@/views/Settings/ThemeSettings")
					},					
					{
						name: "network",
						path: "network",
						component: () => import(/* webpackChunkName: "settings" */"@/views/Settings/NetworkSettings")
					},					
					{
						name: "database",
						path: "database",
						component: () => import(/* webpackChunkName: "settings" */"@/views/Settings/DatabaseSettings")
					},	
					
					{
						name: "mail",
						path: "mail",
						component: () => import(/* webpackChunkName: "settings" */"@/views/Settings/Mail")
					},	
					
					{
						name: "active-directory",
						path: "ad",
						component: () => import(/* webpackChunkName: "settings" */"@/views/Settings/ActiveDirectory")
					},

					{
						name: "enterprise",
						path: "enterprise",
						component: () => import(/* webpackChunkName: "settings" */"@/views/Settings/EnterprisePreview")
					}
				]
			},
		],
	},

	{
		name: "signup-review",
		path: "/signup/review/:uid?",
		component: () => import("@/views/SignupReview"),
	},

	{
		name: "admission-page",
		path: "/id/:list_id/:admission_id",
		component: () => import("@/views/admission/AdmissionEditPage"),

	},

	{
		name: "search-admission-page",
		path: "/search/id/:list_id/:admission_id",
		component: () => import("@/views/admission/AdmissionEditPage"),

	},

	{
		name: "admission-search",
		path: "/search-admissions/:list_id?",
		component: () => import("@/views/admissionSearch/AdmissionSearchPage"),

	},
]
export default routes;